import { Injectable } from '@angular/core';
import { endpoints } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BaseResult } from '../models/base.result.model';

@Injectable()
export class CreditCardService {
	private url = endpoints.creditCard;
	public status = 'NaoProcessado';
	public limite = 0;
	public creditCardImg = '';
	public diaVencimento = 0;

	constructor(private http: HttpClient) { }

	enableCreditCard(day: number): Observable<BaseResult<any>> {
		return this.http.post<BaseResult<any>>(`${this.url.enable}`, { diaVencimento: day });
	}

	getTermsCreditCard() {
		return this.http.get<BaseResult<any>>(`${this.url.terms}`);
	}

	getImgCreditCart() {
		return this.http.get<BaseResult<any>>(`${this.url.imgs}`);
	}
}




// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/shared/cards/credit-card.service.ts